import React from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineBlocks} from 'react-tinacms-inline';
import {Paragraph} from '../Paragraph';
import {Title} from '../Title';
import {simpleBlockFields} from '../../constants/fields/fields';
import {Features} from '../Feature';
import {simpleBlockTemplate} from '../../constants/templates/simpleBlock';
import {Images} from '../Image';
import {Image} from '../Image/Image';
import {GroupContainer} from '../Common/GroupContainer';
import {useBlockProps} from '../../hooks/useBlockProps';

const BLOCKS = {
  paragraph: Paragraph,
  title: Title,
  features: Features,
  images: Images,
  image: Image,
};

const SimpleComponent = ({index, data}) => {
  const {blockProps} = useBlockProps(data);
  return (
    <BlocksControls index={index} focusRing={{offset: 0}} insetControls>
      <div>
        <GroupContainer {...data?.content} viewport={blockProps.viewport}
          className={`shadow-${blockProps?.content?.shadow}`}>
          <div className={'dlf-page-content-group'}>
            <InlineBlocks name={'blocks'}
              itemProps={data?.itemProps}
              blocks={BLOCKS}/>
          </div>
        </GroupContainer>
      </div>
    </BlocksControls>
  );
};

export const SimpleBlock = {
  Component: SimpleComponent,
  template: {
    _template: 'simple',
    label: 'Simple Block',
    defaultItem: simpleBlockTemplate,
    fields: simpleBlockFields
  },
};

SimpleComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
